var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header',{staticClass:"l-header"}),_c('main',[_vm._t("main")],2),(_vm.router.showInput())?_c('InputWord',{staticClass:"l-search"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }